<script>import useStyles from './Burger.styles';
import { UnstyledButton } from '../Button';
import { colorScheme } from '../../styles';
import { get_current_component } from 'svelte/internal';
import { createEventForwarder, useActions } from '../../internal';
export let use = [], element = undefined, className = '', override = {}, opened = true, color = undefined, size = 'md';
export { className as class };
/** An action that forwards inner dom node events from parent component */
const forwardEvents = createEventForwarder(get_current_component());
$: _color = color ? color : $colorScheme === 'dark' ? 'white' : 'black';
$: ({ classes, getStyles, cx } = useStyles({ color: _color, size, opened }, { name: 'Burger' }));
</script>

<UnstyledButton
	bind:element
	use={[forwardEvents, [useActions, use]]}
	override={{ padding: 5 }}
	class={cx(className, classes.root, getStyles({ css: override }))}
	{...$$restProps}
>
	<span class={cx(classes.burger, { opened: opened })} />
</UnstyledButton>
